import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { PipeModule } from '@panaya/ui/pipes';
import { PFieldModule } from '@panaya/ui/p-field';
import { PFieldOutlineTextComponent } from './p-field-outline-text.component';

@NgModule({
    declarations: [PFieldOutlineTextComponent],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        TranslateModule,
        PIconModule,
        PipeModule,
        PFieldModule
    ],
    exports: [PFieldOutlineTextComponent]
})
export class PFieldOutlineTextModule {}
